let settings = {
  "version": "1.0",
  "analytics": {
    "rsids": "cbsietonlinesite",
    "server": "aa.cbsi.com",
    "ssl": false,
    "offlineEnabled": false,
    "charset": "UTF-8",
    "lifecycleTimeout": 300,
    "privacyDefault": "optedin",
    "batchLimit": 0,
    "timezone": "EDT",
    "timezoneOffset": -240,
    "referrerTimeout": 0,
    "backdateSessionInfo": false,
    "poi": []
  },
  "marketingCloud": {
    "org": "10D31225525FF5790A490D4D@AdobeOrg"
  },
  "target": {
    "clientCode": "",
    "timeout": 5
  },
  "audienceManager": {
    "server": "",
    "analyticsForwardingEnabled": true,
    "timeout": 5
  },
  "acquisition": {
    "server": "c00.adobe.com",
    "appid": "35217f7451e428a805f67eecc04dcf672ce42905b8eece207085277df79b7e51",
    "liveStreamGUID": "PIeTZr_epWoWAPvJ6p1bP0KG8l2XzCai"
  },
  "mediaHeartbeat": {
    "server": "cbsinteractive.hb.omtrdc.net",
    "publisher": "10D31225525FF5790A490D4D@AdobeOrg",
    "channel": "Entertainment Tonight Live",
    "ssl": false,
    "ovp": "",
    "sdkVersion": "",
    "playerName": ""
  },
  "messages": [],
  "remotes": {
    "analytics.poi": "https://assets.adobedtm.com/b213090c5204bf94318f4ef0539a38b487d10368/scripts/satellite-5b43902864746d15fa001a89.json",
    "messages": "https://assets.adobedtm.com/b213090c5204bf94318f4ef0539a38b487d10368/scripts/satellite-5b43902864746d3a9a001ef3.json"
  },
  "qos": {
    "name": "MuxQOSPluginJS",
    "category": "qos",
    "enabled": true,
    "params": [
      {
        "name": "propertyKey",
        "value": "2in9ha4ucl0pbt657dhf7561a"
      },
      {
        "name": "subPropertyId",
        "value": "ET Live"
      }
    ]
  },
  "shareURLDomain": "etonline.com",
  "daiURL": "https://dai.google.com/linear/hls/event/xrVrJYTmTfitfXBQfeZByQ/master.m3u8",
  "daiKey": "xrVrJYTmTfitfXBQfeZByQ",
  "dvrRefreshInterval": 5000,
  "vodRefreshInterval": 600000,
  "contentTimeForAds": 360,
  "mpxDvrID": "lHk8J86zluYtkSrNXrpfgmSaFws1dkqP",
  "mpxLiveID": "PIeTZr_epWoWAPvJ6p1bP0KG8l2XzCai",
  "playerPreviewImage": "https://etlive-fastly-cbsaavideo-com.global.ssl.fastly.net/images/hero.png",
  "shareThumbDimension": {
    "sharedThumbWidth": "1280",
    "sharedThumbHeight": "720"
  }
}

export default settings
